import { render, staticRenderFns } from "./ActivityTimeLineItemTags.vue?vue&type=template&id=2c829290&"
import script from "./ActivityTimeLineItemTags.vue?vue&type=script&lang=ts&"
export * from "./ActivityTimeLineItemTags.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports